// notificationsSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

const initialState = {
    message: '',
    type: '',
};

const notificationsSlice = createSlice({
    name: 'toast',
    initialState: {},
    reducers: {
        showToast: (state, action) => {
            // This reducer will handle showing the toast
            const { message, type } = action.payload;
            const options = {
                autoClose: 15000,
                position: toast.POSITION.TOP_RIGHT,
            };
            switch (type) {
                case 'success':
                    toast.success(message, options);
                    break;
                case 'error':
                    toast.error(message, options);
                    break;
                case 'warning':
                    toast.warning(message, options);
                    break;
                default:
                    toast(message); // Default toast
            }
        }
    }
});

export const { showToast } = notificationsSlice.actions;

export default notificationsSlice.reducer;
